module.exports = __webpack_public_path__ + "img/EMT-BRCA_10X_DCIS.683b833a.png";